import { render, staticRenderFns } from "./create-package.vue?vue&type=template&id=596d582a"
import script from "./create-package.vue?vue&type=script&lang=js"
export * from "./create-package.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports